import { type AnnotationType } from '@air/api/types';

export const annotationTooltipText: { [key in AnnotationType]: string } = {
  box: 'Click to comment on a point or drag to select an area',
  pencil: 'Draw on area to add a comment',
};
